import Raymond from '@neo.tax/shared/assets/images/testimonials/raymond.jpg';
import RedVentures from '@neo.tax/shared/assets/images/testimonials/rv.png';
import Sean from '@neo.tax/shared/assets/images/testimonials/sean.jpg';
import ThomsonReuters from '@neo.tax/shared/assets/images/testimonials/tr.svg?url';

export const testimonials = [
  {
    name: 'Sean Cannizzaro',
    titleAndCompany: 'VP - Head of Tax Operations at Thomson Reuters',
    quote:
      "We have used Neo.Tax since our 2023 credit claim, and we've been thoroughly impressed with the tool’s effectiveness. The user-friendly interface made it easy to review the automated conclusions regarding credit eligibility for each project. Neo.Tax significantly reduced the number of interviews we conducted and helped us eliminate a major cost with an external advisor.",
    companyImage: ThomsonReuters,
    image: Sean,
    height: 334,
  },
  {
    name: 'Raymond Salort',
    titleAndCompany: 'Vice President & Director of Taxes at Red Ventures',
    quote:
      "Neo.Tax is the best software we have used in our tax department. Neo.Tax was the highlight of the year for not just our tax team, but for our entire team. Our CFO loved how unbelievable the ROI was, across the tax team and the R&D teams. This is the only AI we've used that actually worked. And it delivered a real, tangible tax output.",
    companyImage: RedVentures,
    image: Raymond,
    height: 334,
  },
] as const;
